import { createBrowserHistory } from 'history';
import { HS_CUSTOM_DOMAIN_PREFIX } from './constants';
const createHistory = () => {
  const baseName = window.location.pathname.startsWith(HS_CUSTOM_DOMAIN_PREFIX) ? `${HS_CUSTOM_DOMAIN_PREFIX}/preferences` : '/preferences';
  return createBrowserHistory({
    basename: baseName
  });
};
export default createHistory();